import { PrepaymentDeadlineKind } from '../model/types';

const NBSP = '\u00A0';

export const DAYS_PLURAL_FORMS = ['день', 'дня', 'дней'];

export const DAYS_GENITIVE_PLURAL_FORMS = ['дня', 'дней', 'дней'];

export const PREPAYMENT_TEXTS = {
  amountFrom: 'от',
  partPrefix: 'по предоплате',
} as const;

export const PREPAYMENT_SHEET_TEXTS = {
  title: 'Предоплата',
  introPrefix: 'По части туров',
  /** Между префиксом и остатком встаёт страна в винительном падеже: «По части туров в Турцию можно...». */
  introCountryPrefix: 'в',
  // Неразрывный пробел стоит там же, где в макете: он держит перенос строки на месте.
  introSuffix: `можно заплатить не${NBSP}всю сумму сразу`,
  optionPart: 'Предоплата',
  note: 'В некоторых случаях туроператор оставляет за собой право изменить условия по срокам оплаты. В случае повышения курса валют доплата будет пересчитана по новому курсу туроператора',
  close: 'Понятно',
} as const;

interface PrepaymentDeadlineTexts {
  prefix: string;
  pluralForms: string[];
  suffix: string;
  hotelOfferSuffix: string;
}

export const PREPAYMENT_DEADLINE_TEXTS: Record<PrepaymentDeadlineKind, PrepaymentDeadlineTexts> = {
  [PrepaymentDeadlineKind.BeforeCheckIn]: {
    prefix: 'Остальное за',
    pluralForms: DAYS_PLURAL_FORMS,
    suffix: 'до вылета',
    hotelOfferSuffix: 'до заселения',
  },
  [PrepaymentDeadlineKind.AfterReservation]: {
    prefix: 'Остальное в течение',
    pluralForms: DAYS_GENITIVE_PLURAL_FORMS,
    suffix: 'после подтверждения тура',
    hotelOfferSuffix: 'после подтверждения бронирования',
  },
};
